import './SiteThumbnail.scss';

export { default } from './SiteThumbnail';
